/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchEquipmentCalendarSchedulesResponseDto } from './search-equipment-calendar-schedules-response-dto';


export interface SearchEquipmentCalendarSchedulesResponseDtoPagedList { 
    totalCount?: number;
    items?: Array<SearchEquipmentCalendarSchedulesResponseDto> | null;
}

